import React from 'react';
import locale from './EnterAddress.locale';
import EnterAddress from './EnterAddress';
import ContactFooter from './ContactFooter';
import usStates from '../../../../helpers/usStates';

class EnterAddressTheHomeDepot extends EnterAddress {
  render() {
    return (
      <div className="homedepotcom">
        <div className="description">
          {locale.instructions}
        </div>
        <form className="enter-address">
          <label htmlFor="line1">Install Address *</label>
          <input
            id="line1"
            name="line1"
            className="textInput full-width"
            value={this.props.address.line1}
            placeholder="Street 1"
            onChange={this.onChange}
          />
          <input
            id="line2"
            name="line2"
            className="textInput full-width"
            value={this.props.address.line2}
            placeholder="Street 2"
            onChange={this.onChange}
          />

          <div className="form-group">
            <label className="city" htmlFor="city">
              City *
              <input
                id="city"
                name="city"
                value={this.props.address.city}
                onChange={this.onChange}
              />
            </label>
            <div className="stateZip">
              <label className="state dropdownInsideLabel" htmlFor="state">
                State *
                <select
                  id="state"
                  name="state"
                  value={this.props.address.state}
                  onChange={this.onChange}
                >
                  {usStates.map(state => (
                    <option key={state.value} name={state.value}>{state.name}</option>
                  ))}
                </select>
                <div className="arrow-down" />
              </label>

              <label className="zipCode" htmlFor="zipCode">
                Zip Code *
                <input
                  id="zipCode"
                  name="zipCode"
                  value={this.props.address.zipCode}
                  onChange={this.onChange}
                />
              </label>
            </div>
          </div>
          <div className="check-availability-container">
            <button
              className="check-availability btn btn-primary"
              onClick={this.proceed}
              disabled={!this.canSubmit()}
            >
              Check Availability
            </button>
          </div>
          <div className="footer full-width">
            <span className="desktop-tablet-only">
              <ContactFooter />
            </span>
            <span className="enter-address mobile-only">
              <ContactFooter />
            </span>
          </div>
        </form>
      </div>
    );
  }
}

export default EnterAddressTheHomeDepot;
